module.exports = __webpack_public_path__ + "img/body_type_man.09638ae4.png";